import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u642891214/domains/hobbyverde.com.br/hbuilds/source/repository/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/u642891214/domains/hobbyverde.com.br/hbuilds/source/repository/src/styles/index.css");
